import { GaugeChart, Modal, Typography } from '@repo/ui';
import c from 'classnames';
import { KitSummaryScore } from 'services/kits/useKitSummaryScores';
import styles from './GaugeChartSectionModal.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  kitSummaryScoreData: KitSummaryScore;
};

export default function GaugeChartSectionModal({
  isOpen,
  onClose,
  kitSummaryScoreData,
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title='About evaluation'
      showHeader
      isDismissable
      className={c(styles.modal)}
    >
      <div className={c(styles.modalBody)}>
        <div className={styles.upperSection}>
          <div className={styles.gaugeChartWrapper}>
            <GaugeChart
              color={kitSummaryScoreData.evaluation_color}
              label={kitSummaryScoreData.evaluation_text}
            />
          </div>
          <div className={styles.upperSectionText}>
            <Typography variant='body-m'>
              How PRO results are evaluated
            </Typography>
            <Typography variant='body-s'>
              Your PRO evaluation provides an overview of PRO stool chemistry
              metrics that reflect key aspects of gut health—including
              digestion, inflammation, and short-chain fatty acids—assessing
              each metric against established reference ranges.
            </Typography>
          </div>
        </div>
        <div className={styles.bottomSection}>
          <Typography variant='body-s' style={{ alignSelf: 'start' }}>
            The PRO evaluation can be:
          </Typography>
          <ul style={{ marginBottom: 0 }}>
            <li>
              <Typography variant='body-s'>
                <span className={styles.typical}>Typical:</span> Most PRO
                metrics are within range, indicating an overall balanced gut.
              </Typography>
            </li>
            <li>
              <Typography variant='body-s'>
                <span className={styles.borderline}>Borderline:</span> Some PRO
                metrics fall outside the expected range, suggesting areas for
                improvement.
              </Typography>
            </li>
            <li>
              <Typography variant='body-s'>
                <span className={styles.needsSupport}>Needs Support:</span>{' '}
                Multiple PRO metrics are out of range or significant concern is
                detected, indicating a need for support.
              </Typography>
            </li>
          </ul>
          <Typography variant='body-s'>
            Review this evaluation alongside other findings and discuss your
            results with your healthcare practitioner for interpretation.{' '}
            <span style={{ fontStyle: 'italic' }}>
              This evaluation does not constitute medical advice, a diagnosis,
              or a clinical assessment. Always review all PRO markers and
              evaluations with a qualified healthcare provider.
            </span>
          </Typography>
        </div>
      </div>
    </Modal>
  );
}
